import { gql } from '@apollo/client';

export const QUERY_PICKUP_SITE_DETAIL = gql`
  query QueryPickupSiteDetail($input: PickupDashboardSiteDetailQueryInput!) {
    queryPickupSiteDetail(input: $input) {
      content {
        siteId
        name
        connectResult
        hubName
        city
        state
        zipcode
        addressLine1
        contactName
        contactPhone
        vehicleType
        isNew
        continuousFailure
        standingPickup
        status
        remark
        createdAt
        updatedAt
      }
      page
      pageSize
      total
    }
  }
`;
